import React, { useEffect, useState } from 'react'
import addToCart from 'src/assets/images/cus-add-to-car-icon.png'
import { faXmark, faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { AppDispatch, RootState } from 'src/Store/store';
import { useDispatch, useSelector } from 'react-redux';
import httpRequest from 'src/helpers/httpRequest';
import { IDiagnosticCartItem } from 'src/types/GlobalInterfaces';
import { toast } from 'react-toastify';
import { truncateString } from 'src/helpers/helperFunctions';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { removeItem } from 'src/Store/cartSlice';
import { CircularProgress } from '@mui/material';
import { tooglePleaseLogin } from 'src/Store/reducer';
import { CURRENCY } from 'src/lib/constans';

const DiagnosticCartModal: React.FC<{ layout: "dashboard" | "webiste" }> = ({ layout = "webiste" }) => {
    const dispatch = useDispatch<AppDispatch>();
    const navigate = useNavigate();
    const { diagnosticProducts } = useSelector((store: RootState) => store.cartSlice);
    const { isLogged } = useSelector((store: RootState) => store.appReducer);
    const [isModal, setIsModal] = useState<boolean>(false);
    const [isLoader, setIsLoader] = useState<boolean>(false);
    const [data, setData] = useState<IDiagnosticCartItem[]>([]);
    const [totalPrice, setTotalPrice] = useState<number>(1);
    const location = useLocation();

    const printLink = (id: string, cartItemType: "package" | "product"): string => {
        const _type = cartItemType === "package" ? "package" : "test";
        if (layout === "dashboard") {
            return `/customer/diagnostic-product-detail/${_type}/${id}/view`;
        } else {
            return `/diagnostic-product/:type/${id}/view`;
        }
    };
    const removeCartItem = (id: string) => {
        dispatch(removeItem({ category: "diagnosticProducts", productId: id }));
        const newData = data?.filter(v => v?._id !== id);
        setData(newData);
        if (!newData.length) {
            setIsModal(false);
        }
    };

    const fetch = async () => {
        setIsLoader(true);
        const { res, err } = await httpRequest<IDiagnosticCartItem[]>({
            method: "post",
            path: "/product/cart-items",
            params: { ids: diagnosticProducts?.map(v => v._id) }
        })
        if (res) {
            setData(res?.map(v => ({ ...v, selectedQuantity: diagnosticProducts?.find(q => q?._id === v?._id)?.quantity || 1 })));
        } else {
            toast(err, { type: "error" });
        }
        setIsLoader(false);
    };
    useEffect(() => {
        setIsModal(false);
    }, [location]);
    useEffect(() => {
        const _total: number = data.reduce((prev, current) => {
            return prev + Number(current?.salePrice || current?.regularPrice);
        }, 0)
        setTotalPrice(_total);
    }, [data]);
    return (
        <>
            {/* {diagnosticProducts?.length ?
                <div className='add-to-cart-cus-layout'>
                    <button onClick={() => {
                        fetch();
                        setIsModal(true);
                    }} className='relative'>
                        <span className='font-size-15px text-white font-Poppins-SemiBold'>{diagnosticProducts.length}</span>
                        <img src={addToCart} alt="" />
                    </button>
                </div>
                : null
            } */}
            {isModal &&
                <div onClick={(e) => {
                    if (e.target === e.currentTarget) {
                        setIsModal(false);
                    }
                }} className='cus-layout-add-to-cart-modal'>
                    <div onClick={(e) => {
                        e.stopPropagation()
                    }} className='cus-layout-add-to-cart-modal-inner'>
                        <div className='modal-header-add-to-cart'>
                            <span className='font-size-20px font-Poppins-SemiBold text-white'>Your Cart ({diagnosticProducts.length})</span>
                            <button onClick={() => setIsModal(false)}>
                                <FontAwesomeIcon className='font-size-20px text-white' icon={faXmark} />
                            </button>
                        </div>
                        <div className='cus-layout-add-to-cart-modal-product-main'>
                            {isLoader &&
                                <div className="text-center">
                                    <CircularProgress size={14} style={{ color: "#004540" }} />
                                </div>
                            }
                            {data.map(item => (
                                <div key={item?._id} className='cus-layout-add-to-cart-modal-product-inner'>
                                    <img className='cus-layout-add-to-cart-modal-product-img' src={`${item?.image}`} alt="" />
                                    <div className='wall-clock-icon-checkout-main'>
                                        <div className='flex justify-between'>
                                            <Link to={printLink(item?._id, item?.cartItemType)} className='font-size-18px w-[60%] theme-color-green font-Poppins-SemiBold block underline'>{truncateString(item?.name || "", 25)}</Link>
                                            <div className="flex items-center gap-1">
                                                <strong className='font-size-18px theme-color-green font-Poppins-SemiBold'>{CURRENCY} {item?.salePrice || item?.regularPrice}</strong>
                                                {item?.salePrice != null && item?.salePrice > 0 && (
                                                    <strong className='font-size-13px line-through font-Poppins-Regular text-[#878787]'>{CURRENCY} {`${item?.regularPrice || "-"}`}</strong>
                                                )}
                                            </div>
                                        </div>
                                        <div className='flex justify-between'>
                                            <span className='font-size-16px text-[#707070] w-[80%] font-Poppins-SemiBold'>{truncateString(item?.description || "", 50)}</span>
                                            <button onClick={() => removeCartItem(item?._id)}>
                                                <FontAwesomeIcon className='font-size-20px theme-color-green' icon={faTrash} />
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                        <div className='cus-layout-add-to-cart-modal-btm-layer'>
                            <div>
                                {/* <span className='block font-size-15px font-Poppins-Medium text-[#707070]'>{`${diagnostic.length} Item`}</span> */}
                                <span className='block font-size-15px font-Poppins-Medium text-[#707070]'>
                                    {`${diagnosticProducts.length} ${diagnosticProducts.length > 1 ? 'Items' : 'Item'}`}
                                </span>

                                <strong className='font-size-18px theme-color-green font-Poppins-SemiBold'>{CURRENCY} {totalPrice}</strong>
                            </div>
                            <button
                                onClick={() =>
                                    isLogged ?
                                        navigate("/customer/diagnostic-cart")
                                        :
                                        dispatch(tooglePleaseLogin(true))
                                }
                                className='font-size-16px text-white font-Poppins-SemiBold'>Continue</button>
                        </div>
                    </div>
                </div>
            }
        </>
    );
};

export default DiagnosticCartModal;